<template>
    <div>
        <div class="account__cart--top d-flex justify-content-center">
            {{ $t("myAccount.yourCart") }}
        </div>
        <div class="px-2 mb-3">
            <div class="account__border"></div>
        </div>
        <div v-if="cart.cart">
            <div v-if="cart.cart.products.length >= 1"
                 class="px-2">
                <div v-for="product in cart.cart.products"
                     class="account__border--gray mb-3">
                    <a :title="product.name"
                       class="account__link"
                       :href="product.product_link">
                        <div class="row no-gutters mb-2">
                            <div class="col-3">
                                <img class="image--full-width"
                                     :src="product.image_link"
                                     alt="">
                            </div>
                            <div class="col-9">
                                <h2 class="pl-2 account__cart--title"><strong>{{ product.name }}</strong></h2>
                            </div>
                        </div>
                    </a>
                    <div class="mb-2">
                        <div class="d-flex mb-1" v-if="product.attribute_promotion_name">
                            <span v-if="product.attribute_promotion_name === 'op'" class="product-list__item__bonus--green ml-auto">{{ $t('combinationPromotion.op') }}</span>
                            <span v-else-if="product.attribute_promotion_name === 'bonus'" class="product-list__item__bonus--red ml-auto">{{ $t('combinationPromotion.bonus') }}</span>
                            <span v-else-if="product.attribute_promotion_name === '2plus1free'" class="product-list__item__bonus--red ml-auto">{{ $t('combinationPromotion.twoPlusOneFree') }}</span>
                            <span v-else-if="product.attribute_promotion_name === 'minus10percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusTenPercent') }}</span>
                            <span v-else-if="product.attribute_promotion_name === 'minus20percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusTwentyPercent') }}</span>
                            <span v-else-if="product.attribute_promotion_name === 'minus25percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusTwentyFivePercent') }}</span>
                            <span v-else-if="product.attribute_promotion_name === 'minus30percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusThirtyPercent') }}</span>
                            <span v-else-if="product.attribute_promotion_name === 'minus40percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusFortyPercent') }}</span>
                            <span v-else-if="product.attribute_promotion_name === 'minus50percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusFiftyPercent') }}</span>
                            <span v-else-if="product.attribute_promotion_name === 'minus60percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusSixtyPercent') }}</span>
                            <span v-else-if="product.attribute_promotion_name === 'minus70percent'" class="product-list__item__bonus--red ml-auto">{{ $t('combination.minusSeventyPercent') }}</span>
                        </div>
                        <div class="d-flex mb-1">
                            <span class="text--gray-mid account--text ">{{ product.quantity }}x</span>
                            <span class="account--text ml-auto">{{ product.total_price_tax_incl }}</span>
                        </div>
                    </div>
                </div>
                <div class="account__border--gray mb-3">
                    <div class="d-flex account--text text--gray-mid mb-3">
                        <span>{{ $t("myAccount.totalShipmentCost") }}: </span>
                        <span v-if="cart.cart.shipping_raw === 0"
                              class="account--text text--green ml-auto">{{ $t("myAccount.freeOfCharge") }}</span>
                        <span v-else
                              class="account--text ml-auto">{{ cart.cart.shipping }}</span>
                    </div>
                </div>
                <div class="account__border--gray mb-3" v-for="cart_rule in cart.cart.cart_rules">
                    <div class="d-flex account--text text--gray-mid mb-3">
                        <span>{{ cart_rule.name }} </span>
                        <span v-if="cart_rule.reduction_amount"
                              class="account--text ml-auto"> - {{ cart_rule.reduction_amount }}</span>
                        <span v-if="cart_rule.reduction_percent"
                              class="account--text ml-auto"> {{ cart_rule.reduction_percent }} %</span>
                    </div>
                </div>
                <div class="account__border">
                    <div class="d-flex mb-4 align-items-center">
                        <div class="account--text text--gray-mid mr-1">{{ $t("myAccount.total") }}</div>
                        <div class="text--sm text--gray-100">{{ $t("myAccount.taxIncl") }}</div>
                        <div class="account--text ml-auto"><strong>{{ cart.cart.total }}</strong></div>
                    </div>
                    <div class="d-flex justify-content-end mb-3">
                        <button
                            v-if="cart.cart.can_order"
                            @click="handleGoToCheckoutButton"
                            class="text-center button-brekz button-brekz--rounded button-brekz--yellow button--icon-left text--gray-600 ml-auto"
                        >
                            <span class="d-none d-md-inline-block">{{ $t("myAccount.continueToOrder") }}</span>
                        </button>
                        <div v-else
                             class="cart-amount-warning alert alert-warning">
                            {{ $t('myAccount.minimumPurchaseMessage', { amount: cart.cart.minimal_purchase }) }}
                        </div>
                    </div>
                </div>

            </div>
            <div v-else
                 class="px-2">
                <div class="py-4 px-2 text-center account__border--gray mb-2">
                    <div class="mb-3">{{ $t("myAccount.easyReorder") }}</div>
                    <div class="account__cart--italic-text">{{ $t("myAccount.easyReorderMessage") }}</div>
                </div>
                <div class="account__border--gray mb-3">
                    <div class="d-flex text--gray-mid mb-3">{{ $t("myAccount.totalShipmentCost") }}:
                        <span class="text--green ml-auto">&euro; -,--</span></div>
                </div>
                <div class="account__border">
                    <div class="d-flex mb-4 align-items-center">
                        <div class="text--gray-mid mr-1">{{ $t("myAccount.total") }}</div>
                        <div class="text--sm text--gray-100">{{ $t("myAccount.taxIncl") }}</div>
                        <!--- todo deze 0 moet worden veranderd -->
                        <div class="ml-auto"><strong>&euro; 0,00</strong></div>
                    </div>
                    <div class="d-flex justify-content-end mb-3">
                        <button
                            v-if="cart.can_order"
                            @click="handleGoToCheckoutButton"
                            class="text-center button-brekz button-brekz--rounded button-brekz--yellow button--icon-left text--gray-600 ml-auto"
                        >
                            <span class="d-none d-md-inline-block">{{ $t("myAccount.continueToOrder") }}</span>
                        </button>
                        <div v-else>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal-vue title=":("
                   :show="showErrorModal"
                   @close="showErrorModal = false"
                   :buttons='[{text: "Oke", class: "button-brekz button-brekz--rounded button-brekz--yellow button--extra-large", emit_name: "close"}]'>
            <p class="my-3 mx-3">{{ $t("myAccount.errorModalText") }}<br/>{{ $t("myAccount.errorModalText2") }}</p>
        </modal-vue>
        <modal-vue :title="QuantityErrorModalContent.title"
                   :show="showQuantityErrorModal"
                   :centerButtons="true"
                   @close="showQuantityErrorModal = false"
                   :content="QuantityErrorModalContent.content"
                   :buttons='[{ text: QuantityErrorModalContent.button, class: "button-brekz button-brekz--rounded button-brekz--green button--extra-large", emit_name: "close" }]'>
        </modal-vue>
    </div>
</template>

<script>
    import Address from "./Address";
    import Account from "./Account";
    import ModalVue from "./ModalVue";

    export default {
        name: "Cart",
        components: {
            Address,
            Account,
            ModalVue,
        },
        props: {
            isMobile: Boolean,
            checkoutLink: String,
            getCartLink: String,
            AccountCartLink: String,
        },
        data() {
            return {
                cart: [],
                count: 0,
                showErrorModal: false,
                showQuantityErrorModal: false,
                QuantityErrorModalContent: {
                    button: '',
                    title: '',
                    content: ''
                },
                updatingItems: [],
                cartQuantity: 0,
            }
        },
        methods: {
            handleGoToCheckoutButton() {
                if (typeof window.pushGAEvent === 'function') {
                    window.pushGAEvent('my_account_proceed_to_checkout', {});

                    setTimeout(() => {
                        document.location.href = this.checkoutLink;
                    }, 250);

                    return;
                }

                document.location.href = this.checkoutLink;
            },
            getCart() {
                jQuery.get(this.getCartLink, data => {
                    this.cart         = data;
                    this.cartQuantity = 0;
                    this.cart.cart.products.some((product) => {
                        this.cartQuantity += parseInt(product.quantity);
                    });
                    const cartQuantityIcon        = document.getElementById('cart-badge--mobile');
                    const cartQuantityIconDesktop = document.getElementById('vue-cart-badge-desktop');
                    cartQuantityIcon.classList.remove('hidden');
                    cartQuantityIcon.innerHTML        = this.cartQuantity;
                    cartQuantityIconDesktop.innerHTML = this.cartQuantity;
                    if (this.cartQuantity === 0) {
                        cartQuantityIcon.classList.add('hidden');
                    }
                });
            },
            editProductQuantity(quantity, product) {

                let data = {
                    quantity: quantity,
                    id_product: product.id_product,
                    id_product_attribute: product.id_product_attribute,
                };

                this.updatingItems.push(product);

                jQuery.ajax({
                    url: this.AccountCartLink + '?action=quantity-product',
                    type: "POST",
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    dataType: 'json',
                    success: response => {
                        if (response.mqcError) {
                            this.QuantityErrorModalContent.button  = response.customtext.button_text
                            this.QuantityErrorModalContent.title   = response.customtext.title
                            this.QuantityErrorModalContent.content = response.errors[0];

                            this.showQuantityErrorModal = true;
                        }
                        this.removeUpdatingStatus(product);
                        this.getCart();
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        this.removeUpdatingStatus(product);
                        console.log('product update failed', XMLHttpRequest.responseText);
                    }
                });
            },
            removeProduct(product) {
                let data = {
                    id_product: product.id_product,
                    id_product_attribute: product.id_product_attribute,
                };

                this.updatingItems.push(product);

                jQuery.ajax({
                    url: this.AccountCartLink + '?action=remove-product',
                    type: "POST",
                    contentType: 'application/json',
                    data: JSON.stringify(data),
                    dataType: 'json',
                    success: response => {
                        this.removeUpdatingStatus(product);
                        this.removeProductFromCartList(product);
                        this.getCart();
                        const cartQuantityIcon     = document.getElementById('cart-badge--mobile');
                        cartQuantityIcon.innerHTML = this.cartQuantity - parseInt(product.quantity);
                    },
                    error: function(XMLHttpRequest, textStatus, errorThrown) {
                        this.showErrorModal = true;
                        this.removeUpdatingStatus(product);
                        console.log('product delete failed', XMLHttpRequest.responseText);
                    }
                });
            },
            isUpdating(product) {
                for(var i = 0; i < this.updatingItems.length; i++) {
                    if (this.updatingItems[i] === product) {
                        return true;
                    }
                }

                return false;
            },
            removeUpdatingStatus(product) {
                for(var i = 0; i < this.updatingItems.length; i++) {
                    if (this.updatingItems[i] === product) {
                        this.updatingItems.splice(i, 1);
                        return true;
                    }
                }

                return false;
            },
            removeProductFromCartList(product) {
                for(var i = 0; i < this.cart.cart.products.length; i++) {
                    if (this.cart.cart.products[i] === product) {
                        this.cart.cart.products.splice(i, 1);
                        return true;
                    }
                }

                return false;
            }

        },
        created() {
            this.getCart();
        },
        mounted() {
            window.EventBus.$on('update-cart', () => {
                this.getCart()
            })

            window.EventBus.$on('set-quantity', product => {
                this.editProductQuantity(product.quantity, product)
            })
            // this.getCart();
        }
    }
</script>
